import React from "react"
import { FlexContainer, Text, Body, Stack } from "@carrotfertility/carotene"
import styled from "styled-components"
import Tooltip from "components/Tooltip"
import { MultiPathSVG } from "components/views/SVG"

const cellStyling = `
  padding-right: 24px;
  text-align: left;
  padding-top: 40px;
`
const RowHeader = styled.th`
  ${cellStyling}
  width: 420px;
`
const RowCell = styled.td`
  ${cellStyling}
`

const HelpIconContainer = styled.span`
  margin-left: 5px;
  display: inline-block;
  vertical-align: text-top;
  color="#e48400" 
`

const ItalizedText = styled(Text)`
  font-style: italic;
`

const TooltipParagraphs = ({ tooltipText }: { tooltipText: string[] }): JSX.Element => (
  <Stack sx={{ padding: "32px 24px" }} spacing="small">
    {tooltipText.map((text, index) => (
      <Body key={index}>{text}</Body>
    ))}
  </Stack>
)

export type InsurancePlanInformationRowData = {
  headerLabel: string
  memberData?: string
  partnerData?: string
  tooltipText?: string[]
  helperText?: string
}

export interface InsurancePlanInformationRowProps extends InsurancePlanInformationRowData {
  hasPartner: boolean
}

const PlanInformationRow = (props: InsurancePlanInformationRowProps): JSX.Element => {
  const { headerLabel, memberData, partnerData, tooltipText, helperText, hasPartner } = props

  return (
    <>
      <tr>
        <RowHeader>
          <FlexContainer>
            <Text weight="bold" size="medium">
              {headerLabel}
              {tooltipText && (
                <Tooltip content={(): JSX.Element => <TooltipParagraphs tooltipText={tooltipText} />}>
                  <HelpIconContainer>
                    <MultiPathSVG iconName="icn-help-orange" />
                  </HelpIconContainer>
                </Tooltip>
              )}
            </Text>
          </FlexContainer>
          <ItalizedText variant="subtext" size="medium">
            {helperText}
          </ItalizedText>
        </RowHeader>
        <RowCell>
          <Text size="medium">{Boolean(memberData) ? memberData : "--"}</Text>
        </RowCell>
        {hasPartner && (
          <RowCell>
            <Text size="medium">{Boolean(partnerData) ? partnerData : "--"}</Text>
          </RowCell>
        )}
      </tr>
    </>
  )
}

export default PlanInformationRow
